<template>
  <div class="cart__skeleton">
    <div class="items">
      <el-skeleton animated>
        <template slot="template">
          <el-skeleton-item variant="h3" />
          <div class="actions">
            <el-skeleton-item variant="p"/>
            <el-skeleton-item variant="p" />
          </div>
          <div class="items-cart">
            <CartItemSkeleton
              v-for="(item, index) in 7" :key="index"
            />
          </div>
        </template>
      </el-skeleton>
    </div>
    <div class="summary">
      <el-skeleton animated>
        <template slot="template">
          <el-skeleton-item variant="h3"/>
          <el-skeleton-item variant="p"/>
          <el-skeleton-item variant="p"/>
          <el-skeleton-item variant="p"/>
          <el-skeleton-item variant="p"/>
        </template>
      </el-skeleton>
    </div>
  </div>
</template>

<script>
import CartItemSkeleton from '@/components/skeleton/CartItem'

export default {
  name: 'Cart_Skeleton',
  components: {
    CartItemSkeleton
  }
}
</script>

<style lang="scss" scoped>
.cart__skeleton {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .el-skeleton__h3 {
    height: 40px;
  }
  .items {
    width: 70%;
    &::v-deep .el-skeleton {
      .el-skeleton__h3 {
        width: 20%;
      }
      .actions {
        display: flex;
        justify-content: space-between;
        .el-skeleton__p {
          width: 15%;
          height: 25px;
        }
      }
      .items-cart {
        margin-top: 20px;
      }
    }
  }
  .summary {
    width: 25%;
    border-radius: 5px;
    border: 2px solid rgb(240, 240, 240);
    padding: 15px;
    height: 170px;
    &::v-deep .el-skeleton {
      background: white;
      .el-skeleton__h3 {
        width: 50%;
      }
    }
  }
}
</style>